<template>
  <div>
    <div class="my-6">
      <h3 class="font-bold">List of {{ route.name }}</h3>
      <span class="text-sm text-gray-500"
        >Here you can observe all items related to the discipline.
      </span>
    </div>
    <div class="flex mb-6 justify-end">
      <router-link to="/disciplines/create">
        <Button
          color="primary"
          :text="`Create new ${route.name.toLowerCase()}`"
        />
      </router-link>
    </div>
    <div class="card">
      <DataTable
        :headers="headers"
        :data="data"
        :options="options"
        color="primary"
      />
    </div>
  </div>
</template>

<script>
import DataTable from "../../components/Elements/Datatable.vue";
import Button from "../../components/Elements/Button.vue";
import { inject, onMounted, ref } from "vue";
import { GET, DELETE, PATCH } from "../../services/api";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "labels",
  components: {
    DataTable,
    Button,
  },
  setup() {
    const headers = [
      { key: "Id", value: "id" },
      { key: "Name", value: "name" },
      { key: "Status", value: "active" },
      { key: "Options", value: "" },
    ];

    const route = useRoute();
    const router = useRouter();
    const modal = inject("modal");
    const alert = inject("alert");
    const loader = inject("loading");
    const data = ref([]);

    const loadDisciplines = async () => {
      const disciplines = await GET("disciplines");
      data.value = disciplines.map(el => {
        return {
          ...el,
          active: el.deleted_at == null ? 'active' : 'desactive'
        }
      }).sort((a, b) => a.id < b.id ? -1 : (a.id > b.id ? 1 : 0));
    };

    onMounted(async () => {
      try {
        loader.open();
        await loadDisciplines();
        loader.close();
      } catch (e) {
        loader.close();
        if (
          e.includes("Token") ||
          e.includes("t_dynamik") ||
          e == "Unauthorized"
        ) {
          localStorage.removeItem("t_dynamik");
          localStorage.removeItem("info_dynamik");
          router.push({ path: "/login" });
        }
        alert.open("Error", e, "danger");
      }
    });

    const deleteItem = (project) => {
      loader.open();
      const deleteFunction = async function () {
        try {
          loader.open();
          await DELETE(`disciplines/${project.id}`);
          data.value = data.value.filter((item) => item.id != project.id);
          loader.close();
          alert.open(
            "Success!",
            `Discipline was deleted successfully!`,
            "success"
          );
        } catch (e) {
          loader.close();
          if (
            e.includes("Token") ||
            e.includes("t_dynamik") ||
            e == "Unauthorized"
          ) {
            localStorage.removeItem("t_dynamik");
            localStorage.removeItem("info_dynamik");
            router.push({ path: "/login" });
          }
          alert.open("Error", e, "danger");
        }
      };
      modal.open(
        "Attention",
        "Do you really wish to delete this discipline?",
        "warning",
        "Yes",
        () => deleteFunction(),
        modal.close()
      );
      loader.close();
    };

    const changeStatus = (discipline) => {
      try {
        const statusFunction = async function () {
          try {
            loader.open();
            await PATCH(`disciplines/${discipline.id}`, { 
              deleted_at: discipline.deleted_at ? null : new Date().toISOString() 
            });
            await loadDisciplines();
            loader.close();
            alert.open("Success!", `Discipline status was updated successfully!`, "success");
          } catch (e) {
            loader.close();
            if (
              e.includes("Token") ||
              e.includes("t_dynamik") ||
              e == "Unauthorized"
            ) {
              localStorage.removeItem("t_dynamik");
              localStorage.removeItem("info_dynamik");
              router.push({ path: "/login" });
            }
            alert.open("Error", e, "danger");
          }
        }
        loader.open();
        modal.open(
          "Attention",
          "Do you really wish to change this discipline status?",
          "warning",
          "Yes",
          () => statusFunction(),
          modal.close()
        );
        loader.close();
      } catch (error) {
        loader.close();
      }
    }

    const options = [
      { icon: "block", action: (param) => changeStatus(param), title: "Change status", use: 'active' },
      { icon: "pen", path: "/disciplines/edit", title: "Edit label" },
      {
        icon: "trash",
        action: (param) => deleteItem(param),
        title: "Delete label",
      },
    ];

    return { headers, data, options, route };
  },
};
</script>

<style>
</style>